import { BootStep } from '../types/boot';
import { i18n } from './i18n';

export const bootSteps: BootStep[] = [i18n];
